function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.15 0L0 1.147l6.5 6.479 6.5-6.48L11.85 0 6.5 5.332 1.15 0z",
  fill: "#000"
});

function SvgDownChevronDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "b72d7c324e757f9cbd6f9be15ea30e50.svg";
export { SvgDownChevronDark as ReactComponent };